<template lang="pug">
.rent-object-asset-manager-wrapper
  h2.title.is-6 Grundrissbilder für die Webseite
  Uploader(:id="id" @fileUploaded="fetchAllImages()")

  .image-gallery
    draggable(v-model="rentObjectImagesWebsiteSort" v-bind="dragOptions" @change="(e) => drop(e, 'updateWebsiteOrder')")
      transition-group(type="transition" name="flip-list")
        .image-card(v-for="img in rentObjectImagesWebsiteSort" :key="img.websiteSortOrder" :class="{inactive: !img.isActive}")
          .inacive-icon(v-if="img.isActive === false")
            b-icon(icon="minus-circle" type="is-white")
          .image
            img(:src="img.thumbnailUrl")
          .hover-element
            .description {{ img.description }}
            .actions
              b-tooltip(label='Bearbeiten' type='is-secondary' position='is-bottom' :delay="1250")
                b-button(icon-right="pencil", type="is-secondary" @click="openModal(img)")
              .spacer.sm.inline
              b-tooltip(label='Dauerhaft löschen' type='is-danger' position='is-bottom' :delay="1250")
                b-button(icon-right="close", type="is-danger" @click="deleteRentObjectImage(img.id)")

  b-modal(v-model='isModalActive' has-modal-card='' trap-focus='' :destroy-on-hide='false' aria-role='dialog' aria-modal='')
    template(#default='props')
      .card.form.w320.margin-top
        .top
          h2.title.is-6(v-if="formData.id") Bilddaten aktualisieren
          img(:src="formData.thumbnailUrl")
          ValidationObserver(v-slot="{ handleSubmit }", ref="form")
            ValidationProvider(
              name="Beschreibung",
              rules="",
              v-slot="{ errors, valid }"
            )
              b-field(
                label="Meta-Beschreibung",
                label-position="on-border",
                :type="{ 'is-danger': errors[0], 'is-success': valid }",
                :message="errors"
              )
                b-input(v-model="formData.description" maxlength="125" type="textarea")
            ValidationProvider(
              name="Bild aktiv",
              rules="required",
              v-slot="{ errors, valid }"
            )
              b-field(
                :type="{ 'is-danger': errors[0], 'is-success': valid }",
                :message="errors"
              )
                b-switch(v-model="formData.isActive" type="is-success") Bild aktiv

              .button-wrapper.margin-top.right
                b-button(
                  type="is-light",
                  @click="isModalActive = false"
                ) Abbrechen
                b-button(
                  v-if="formData.id"
                  type="is-primary",
                  @click="handleSubmit(updateRentObjectImage)"
                ) Aktualisieren
</template>

<script>
import draggable from 'vuedraggable';
import Uploader from "@/components/molecules/GroundplanUploader.vue";

export default {
  components: {
    draggable,
    Uploader
  },
  props: {
    id: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      rentObjectImagesWebsiteSort: [],
      rentObjectImagesOfferSort: [],
      isModalActive: false,
      formData: {
        description: null,
        isActive: true,
      },
    }
  },
  methods: {
    openModal(p) {
      this.formData = {...this.formData, ...p};
      this.isModalActive = true;
    },
    async drop(payload, target) {
      try {
        await this.$store.dispatch(`rentObjectGroundplanImages/${target}`, {
          id: payload.moved.element.id,
          rentObjectId: this.id,
          position: payload.moved.newIndex
        });
        this.$nextTick(() => {
          this.fetchAllImages();
        });
      } catch {
        this.fetchAllImages();
      }
      this.$buefy.toast.open(`Verschoben von Position ${payload.moved.oldIndex + 1} auf ${payload.moved.newIndex + 1}`)
    },
    async updateRentObjectImage() {
      await this.$store.dispatch("rentObjectGroundplanImages/update", this.formData);
      this.fetchAllImages();
      this.isModalActive = false;
    },
    deleteRentObjectImage(id) {
      this.$buefy.dialog.confirm({
        title: "Bild löschen",
        message: `Sind Sie sicher, dass Sie dieses Bild löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.`,
        confirmText: "Jetzt löschen",
        cancelText: "Abbrechen",
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          await this.$store.dispatch("rentObjectGroundplanImages/delete", {
            id,
          });
          this.fetchAllImages();
        },
      });
    },
    async fetchAllImages() {
      const rentObjectImages = await this.$store.dispatch("rentObjectGroundplanImages/findAll", {
        id: this.id,
      });
      this.rentObjectImagesWebsiteSort = JSON.parse(JSON.stringify(rentObjectImages.sort((a, b) => a.websiteSortOrder - b.websiteSortOrder)));
      this.rentObjectImagesOfferSort = JSON.parse(JSON.stringify(rentObjectImages.sort((a, b) => a.offerSortOrder - b.offerSortOrder)));
    }
  },
  computed: {
    rentObjectImagesWatchter() {
      return this.$store.state.rentObjectImages.all;
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  async mounted() {
    this.fetchAllImages();
  }
};
</script>

<style lang="scss" scoped>
.image-gallery {
  margin: $md-space 0;
}

.image-card {
  display: inline-block;
  margin: $xs-space;
  width: 196px;
  background-color: white;
  border-radius: 3px;
  overflow: hidden;
  box-shadow: $shadow-lg;
  position: relative;
  cursor: move;

  &:hover {
    .hover-element {
      bottom: 0;
    }
  }

  &.activeSlot {
    border: solid 8px $success;
  }

  .inacive-icon {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba($danger, 0.72);
    z-index: 1;
  }

  .image {
    width: 100%;
    height: calc(100% - 32px - 32px);
    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }

  .hover-element {
    position: absolute;
    width: 100%;
    height: 100%;
    bottom: 100%;
    left: 0;
    z-index: 2;
  }

  .description {
    width: 100%;
    min-height: 40px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    background-color: rgba(white, 0.4);
    padding: $sm-space $sm-space 0 $sm-space;
  }
  .actions {
    text-align: center;
    width: 100%;
    padding: $sm-space;
  }
}

.flip-list-enter {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>